import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element, isAdmin }) => {
    const userData = JSON.parse(localStorage.getItem("userLogin")) || {};
    const token = userData?.access_token
    const role = userData?.role

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (isAdmin && role !== "Admin") {
        return <Navigate to="/" replace />;
    }

    return element;
};

export default ProtectedRoute;
